module.exports = __webpack_public_path__ + "europa-10-paper.jpg?60d5b8719f0c5a4e9967641ec3e123b7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/europa-10-paper.jpg
// module id = 246
// module chunks = 0